import {combineReducers} from 'redux';

import {accessories} from './accessories/accessories';
import {applyingAllowance} from './applyingAllowance/applyingAllowance';
import {cartStatus} from './cartStatus/cartStatus';
import {cartTotals} from './cartTotals/cartTotals';
import {messages} from './messages/messages';
import {applePayExpress} from './payments/applePayExpress/applePayExpress';
import {payPalExpress} from './payments/paypalExpress/paypalExpress';
import {placeOfInteraction} from './placeOfInteraction/placeOfInteraction';
import {quoteInfo} from './quoteInfo/quoteInfo';
import {quoteItems} from './quoteItems/quoteItems';
import {quoteItemsCount} from './quoteItemsCount/quoteItemsCount';
import {specialOffer} from './specialOffer/specialOffer';

export const cart = combineReducers({
    accessories,
    applePayExpress,
    applyingAllowance,
    count: quoteItemsCount,
    messages,
    payPalExpress,
    placeOfInteraction,
    quoteInfo,
    quoteItems,
    specialOffer,
    status: cartStatus,
    totals: cartTotals,
});
